import CloseButton from "assets/svgs/close-button.svg";
import Link from "next/link";

export function Sidebar({
  selectedCity,
  selectedState,
  localCases,
  handleCloseButtonClick,
}) {
  return (
    <div className="absolute left-2 right-2 top-2 bottom-2 z-10 lg:w-1/4 lg:left-1 lg:top-1 lg:bottom-1">
      <div className="bg-white flex-shrink-0 h-full overflow-y-auto pt-4 px-4 py-12 lg:w-56">
        <div className="flex items-center justify-end">
          <CloseButton
            className="right-4 top-4 h-4 w-4"
            onClick={handleCloseButtonClick}
          />
        </div>

        <h3 className="text-sm">
          Cases in {selectedCity && selectedCity},{" "}
          {selectedState && selectedState}
        </h3>
        <ul>
          {localCases.map((item) => (
            <li className="py-2" key={`${item.first_name}-${item.last_name}`}>
              <Link href={`/cases/${item.slug}`}>
                <a className="text-sm font-semibold text-red hover:text-red-700">
                  {item.first_name} {item.last_name}
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
